// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius);
  padding: 16px;
  text-align: center;
}

.timer-compact {
  flex-direction: row;
  gap: 8px;
  padding: 4px 8px 4px 12px;
  margin: 0;
  border-radius: 999px;
}

.timer-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--vb-text-muted);
}

.timer-display {
  font-family: var(--vb-font-score);
  font-size: 3rem;
  font-weight: 800;
  color: var(--vb-text);
  letter-spacing: 0.04em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.timer-compact .timer-display {
  font-size: 1.15rem;
}

.timer-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--vb-navy);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: var(--vb-radius-pill);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}

.timer-compact .timer-button {
  width: 32px;
  height: 32px;
  padding: 0;
}

.timer-button.is-running {
  background: var(--vb-danger);
}

body.night-mode .timer-button {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

body.night-mode .timer-button.is-running {
  background: var(--vb-danger);
  color: #fff;
}

.timer-input {
  font-family: var(--vb-font-score);
  font-size: 2.4rem;
  width: 200px;
  text-align: center;
  padding: 6px;
  border: 2px solid var(--vb-primary);
  border-radius: var(--vb-radius-sm);
  background: var(--vb-surface-2);
  color: var(--vb-text);
}

.timer-compact .timer-input {
  font-size: 1.1rem;
  width: 96px;
  margin: 0;
  padding: 2px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Timer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".timer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius);\n  padding: 16px;\n  text-align: center;\n}\n\n.timer-compact {\n  flex-direction: row;\n  gap: 8px;\n  padding: 4px 8px 4px 12px;\n  margin: 0;\n  border-radius: 999px;\n}\n\n.timer-label {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--vb-text-muted);\n}\n\n.timer-display {\n  font-family: var(--vb-font-score);\n  font-size: 3rem;\n  font-weight: 800;\n  color: var(--vb-text);\n  letter-spacing: 0.04em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.timer-compact .timer-display {\n  font-size: 1.15rem;\n}\n\n.timer-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--vb-navy);\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: var(--vb-radius-pill);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.timer-compact .timer-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n\n.timer-button.is-running {\n  background: var(--vb-danger);\n}\n\nbody.night-mode .timer-button {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\nbody.night-mode .timer-button.is-running {\n  background: var(--vb-danger);\n  color: #fff;\n}\n\n.timer-input {\n  font-family: var(--vb-font-score);\n  font-size: 2.4rem;\n  width: 200px;\n  text-align: center;\n  padding: 6px;\n  border: 2px solid var(--vb-primary);\n  border-radius: var(--vb-radius-sm);\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n}\n\n.timer-compact .timer-input {\n  font-size: 1.1rem;\n  width: 96px;\n  margin: 0;\n  padding: 2px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
